import { useAuthStore } from '@/auth/authStore';
import type { SalePriceFields } from '@/shop/sale';

export type SkillType = 'disrupt' | 'shield';

export interface SkillShopEntry extends SalePriceFields {
  skill: SkillType;
  priceCoins: number;
  priceGems: number;
  unlockLevel: number;
  dailyLimit: number;
  dailyAdLimit: number;
  owned: number;
  boughtToday: number;
  adToday: number;
  myLevel: number;
  unlocked: boolean;
}

import { SERVER_URL, COMMON_HEADERS } from '@/config/serverUrl';
const BASE = SERVER_URL;

async function req<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = useAuthStore.getState().token;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...COMMON_HEADERS,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body == null ? undefined : JSON.stringify(body),
    credentials: 'include',
  });
  if (!res.ok) {
    let detail = '';
    try { const j = await res.json(); detail = j?.message ?? j?.error ?? ''; } catch { /* */ }
    throw new Error(detail || `Skills API ${res.status}`);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export const skillsApi = {
  list: () => req<{ items: SkillShopEntry[] }>('GET', '/shop/skills/'),
  skins: () => req<Record<SkillType, string | null>>('GET', '/shop/skills/skins'),
  buy: (skill: SkillType, currency: 'coins' | 'gems', qty = 1) =>
    req<{ owned: number; coins: number; gems: number; boughtToday: number }>(
      'POST', `/shop/skills/${skill}/buy`, { currency, qty },
    ),
  adReward: (skill: SkillType) =>
    req<{ owned: number; adToday: number }>('POST', `/shop/skills/${skill}/ad-reward`),
};
